import { useMemo } from 'react';

import {
  CreateCompleteVersionDto,
  TaxonomyGetResponse,
} from '@/services/TaxonomiesService';

interface UseTaxonomyCategoriesProps {
  taxonomies: TaxonomyGetResponse[];
  taxonomiesUpdated: CreateCompleteVersionDto;
  categories: string[];
}

export function useTaxonomyCategories({
  taxonomiesUpdated,
  categories,
}: UseTaxonomyCategoriesProps) {
  const newCategories = useMemo(() => {
    const activeItems = taxonomiesUpdated.data.filter((item) => {
      const isRemoved = taxonomiesUpdated.taxonomiesToRemove.some(
        (removedItem) => JSON.stringify(removedItem) === JSON.stringify(item),
      );
      return !isRemoved;
    });

    const categoryNames = activeItems
      .map((item) => item.categoryName)
      .filter((cat): cat is string => !!cat);

    const uniqueCategoryNames = [...new Set(categoryNames)];

    return uniqueCategoryNames.filter((cat) => !categories.includes(cat));
  }, [taxonomiesUpdated, categories]);

  const sortedCategories = useMemo(() => {
    return [
      ...categories,
      ...newCategories.filter((c) => !categories.includes(c)),
    ].sort((a, b) =>
      a.localeCompare(b, navigator.language || 'en-US', {
        sensitivity: 'base',
      }),
    );
  }, [categories, newCategories]);

  return { sortedCategories };
}
